/**
 * Modal Template Loader
 *
 * This module loads modal templates using Vite's ?raw import feature
 * and injects them into the DOM at build time. This approach eliminates
 * the need for runtime fetching and improves performance.
 *
 * Phase 3c: Modal Template Extraction
 */

// Import modal templates as raw HTML strings at build time
import paymentMethodModal from './modals/payment-method-modal.html?raw';
import newCustomerModal from './modals/new-customer-modal.html?raw';
import serviceSelectionModal from './modals/service-selection-modal.html?raw';
import customerSelectionModal from './modals/customer-selection-modal.html?raw';
import successModal from './modals/success-modal.html?raw';

/**
 * Load and inject all modal templates into the DOM
 * This function should be called once when the page loads
 */
export function loadModals() {
  // Get the main content container where modals should be inserted
  const mainContent = document.querySelector('main.main-content');

  if (!mainContent) {
    console.error('Modal Loader: Could not find main.main-content container');
    return;
  }

  // Create a temporary container to hold all modals
  const modalContainer = document.createElement('div');
  modalContainer.innerHTML = [
    paymentMethodModal,
    newCustomerModal,
    serviceSelectionModal,
    customerSelectionModal,
    successModal
  ].join('\n');

  // Insert all modals at the beginning of main content
  // This ensures modals are available before the rest of the content
  while (modalContainer.firstChild) {
    mainContent.insertBefore(modalContainer.firstChild, mainContent.firstChild);
  }

  console.log('✓ Modal templates loaded successfully (5 modals)');
}

/**
 * Initialize modal loader
 * Call this function when the DOM is ready
 */
export function initModalLoader() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadModals);
  } else {
    // DOM already loaded
    loadModals();
  }
}

// Auto-initialize when module is imported
initModalLoader();
